import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.jpg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { TranslatedText } from './TranslatedText';
import { useLanguage } from '../context/LanguageContext';

export const Banner = () => {
  const { language } = useLanguage();
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  
  // Define rotating texts based on language
  const rotatingTexts = {
    en: [
      "Web Developer",
      "Software Engineering Student",
      "Dancer Aficionado",
      "Tennis Buff"
    ],
    zh: [
      "网页开发者",
      "软件工程学生",
      "舞蹈爱好者",
      "网球爱好者"
    ]
  };
  
  // Use the appropriate array based on current language
  const toRotate = rotatingTexts[language] || rotatingTexts['en'];
  
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(80);
  const period = 2000;

  // Reset text when language changes
  useEffect(() => {
    setText("");
    setLoopNum(0);
    setIsDeleting(false);
  }, [language]);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => {
      clearInterval(ticker);
    };
  }, [text, delta]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(20);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(80);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={isVisible ? "animate_animated animate_fadeIn" : ""}
                >
                  <span className="tagline">
                    <TranslatedText textKey="welcomeToPortfolio" />
                  </span>
                  <h1 className="responsive-heading">
                    <TranslatedText textKey="greeting" />
                    <span className="wrap">{text}</span>
                  </h1>
                  <p className="responsive-text">
                    <TranslatedText textKey="summary" />
                  </p>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <div className="header-img-container">
              <img
                src={headerImg}
                alt="Header Img"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};